import './AboutMe.css';
import { Container, Row, Col } from "react-bootstrap";
import resume from './img/resume.svg';
import aboutmeIMG from './img/aboutmeIMG.svg';
import email from './img/email.svg';
import download from './img/download.svg';
import links from "../../../assets/data/links.json";

export const AboutMe = () => {
  return (
    <div className='bg-abt' id="about">

      <Container className='aboutme'>
        <Row>
          <Col>

            <Container className='about-bx'>
              <Row>
                <Col>
                  <div className='about-bx-txt'>
                    <img src={aboutmeIMG} alt="resume" />
                    <h1>About Me</h1>
                    <p>Hello and welcome to my portfolio website! <br></br>
                      <br></br>
                      My name is Andrew, and I am an ambitious and innovative Software Engineer looking for opportunities to learn and progress in software development. I am constantly seeking out new ways to improve my skills and stay ahead of the curve in this rapidly-evolving field.
                      <br></br>
                      <br></br>
                      Whether it's through personal projects, exploring the latest technologies, or learning from my peers and through resources like GitHub, Reddit, or Youtube, I am always looking for opportunities to grow and learn.
                      <br></br>
                      <br></br>
                      As a programmer, I pride myself on my creativity and innovative approach to problem-solving. I enjoy finding unique and effective solutions to challenges, and I am always eager to take on new projects that allow me to test and expand my skills.
                      <br></br>
                      <br></br>
                      I am excited to continue my journey in the technology field and am actively seeking a software engineer role where I can make a meaningful contribution and continue to grow as a professional. Thank you for visiting my website, and I hope to connect with you soon.
                      <br></br>
                      <br></br>

                      <i>You miss 100% of the shots you don't take. - Wayne Gretzky</i>
                    </p>

                    <Row className='about-bx-btn-container'>
                      <Col className='coll'>
                        <button className="about-bx-btn-button">
                          <a href="#connect">Contact Me<img src={email} alt="email" className='social-icons' /></a>
                        </button>
                      </Col>
                      <Col className='coll'>
                        <button className="about-bx-btn-button">
                          <a href={links.resumeLink} target="_blank" rel="noopener noreferrer">Download Resume<img src={download} alt="download" className='social-icons' /></a>
                        </button>
                      </Col>
                    </Row>
                  </div>
                </Col>

              </Row>
            </Container>

          </Col>
          <Col>
            <div className="window">
              <div className="titlebar">
                <div className="buttons">
                  <div className="close">
                    <a className="closebutton" href="#connect"><span><strong>x</strong></span></a>

                  </div>
                  <div className="minimize">
                    <a className="minimizebutton" href="#projects"><span><strong>&ndash;</strong></span></a>
                  </div>
                </div>
                Resume.pdf
              </div>
              <div className="content">
                {/* Convert resume to svg https://cloudconvert.com/pdf-to-svg */}
                <img src={resume} alt="resume" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>

    </div>
  )
}